<template>
  <div>
    <list
      row-key="BalanceChangeId"
      ref="list"
      unit="余额修改信息"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="CustomerName"
          label="客户名称"
          min-width="170px"
          show-overflow-tooltip
        />
        <el-table-column prop="OrderNo" label="流水号" min-width="180px" />
        <el-table-column
          prop="OriginalBalance"
          label="原余额"
          min-width="100px"
        />
        <el-table-column prop="Balance" label="修改余额" min-width="100px" />
        <el-table-column prop="AddTime" label="修改时间" min-width="100px">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDateString(row.AddTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Status"
          label="修改状态"
          align="center"
          width="100px"
        >
          <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.Status == 0">待审核</el-tag>
            <el-tag type="success" v-if="row.Status == 1">审核通过</el-tag>
            <el-tag type="danger" v-if="row.Status == 2">审核不通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="MakeEmpName" label="制单人" min-width="100px" />
        <el-table-column prop="ReviewEmpName" label="审核人" min-width="100px" />
        <el-table-column
          prop="Remark"
          label="备注"
          min-width="200px"
          show-overflow-tooltip
        />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list, customer },
  data() {
    return {
      api: require("@/api/sy/balanceChange").default,
      params: {
        CustomerId: 0,
        CustomerName: "",
      },
    };
  },
  methods: {
    setSupplier(data) {
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
    },
  },
};
</script>